<template>
    <form class="order-search__card " autocomplete="off">
        <div class="card-header">
            <h5 class="card-title">Order Search Configuration</h5>
            <hr>
        </div>
        <div class="card-body">
            <div>
                Select the fields to display on Order Search.  If none are selected, default columns will appear.
                <strong>Drag & Drop column names to change their order.</strong>
            </div>

            <div class="list">
                <TransitionGroup name="flip-list" tag="div">
                    <li 
                        v-for="(column,index) in columnData" 
                        :key="index" 
                        class="item"
                        :class="{over: (column === over.column && column !== dragFrom), [over.dir]: (column === over.column && column !== dragFrom) }"
                        @dragstart="(e) => startDrag(column, index, e)"
                        @dragend="(e) => finishDrag(column, index, e)"
                        @dragover="(e) => onDragOver(column, index, e)"
                        draggable="true"
                    >
                        <Checkbox :label="column.ColumnName" v-model="column.isActive" class="col-4" style=""/>
                    </li>
                </TransitionGroup>
            </div>
        </div>
    </form>
</template>

<script>
    import { TableConfigService } from '../services';
    import Checkbox from './inputComponents/Checkbox.vue';

    export default {
        name: "OrderSearchTableConfig",
        components: {
            Checkbox
        },
        data: () => {
            return {
                columnData: [
                    { Id: 1, isActive: false, ColumnName: 'Order #', Field: 'OrderNumber', type: 'string', width: '150px' },
                    { Id: 2, isActive: false, ColumnName: 'Order Date', Field: 'CreatedOn', type: 'date', width: '100px'},
                    { Id: 3, isActive: false, ColumnName: 'Order Owner', Field: 'SalesRepFullName', type: 'string', width: '175px'},
                    { Id: 4, isActive: false, ColumnName: 'Worksheet Name', Field: 'WorksheetName', type: 'string', width: '175px'},
                    { Id: 5, isActive: false, ColumnName: 'Customer #', Field: 'JdeNumber', type: 'string', width: '75px'},
                    { Id: 6, isActive: false, ColumnName: 'Bill Name', Field: 'BillingInfo.Name', type: 'string', width: '75px'},
                    { Id: 7, isActive: false, ColumnName: 'Bill State', Field: 'BillingInfo.StateProvince', type: 'string', width: '75px'},
                    { Id: 8, isActive: false, ColumnName: 'Bill City', Field: 'BillingInfo.City', type: 'string', width: '75px'},
                    { Id: 9, isActive: false, ColumnName: 'Ship Name', Field: 'ShippingInfo.Name', type: 'string', width: '75px'},
                    { Id: 10, isActive: false, ColumnName: 'Ship State', Field: 'ShippingInfo.StateProvince', type: 'string', width: '75px'},
                    { Id: 11, isActive: false, ColumnName: 'Ship City', Field: 'ShippingInfo.City', type: 'string', width: '75px'},
                    { Id: 12, isActive: false, ColumnName: 'Install Date', Field: 'InstalledOn', type: 'date', width: '75px'},
                    { Id: 13, isActive: false, ColumnName: 'Revise Date', Field: 'RevisedOn', type: 'date', width: '75px'},
                    { Id: 14, isActive: false, ColumnName: 'Expire Date', Field: 'ExpiresOn', type: 'date', width: '75px'},
                    { Id: 15, isActive: false, ColumnName: 'Additional Rep 1', Field: 'AdditionalRepName', type: 'string', width: '75px'},
                    { Id: 16, isActive: false, ColumnName: 'Sales Rep', Field: 'EquipmentRepName', type: 'string', width: '75px'},
                ],
                actions: [
                    {
                        hint: 'Hide',
                        icon: 'clear',
                        emit: 'clearActive',
                        visible: (item) => item.isActive
                    },
                    {
                        hint: 'Show',
                        icon: 'plus',
                        emit: 'setActive',
                        visible: (item) => !item.isActive
                    },
                ],
                startLoc: 0,
                dragging: false,
                dragFrom: {},
                over: {}
            }
        },
        computed: {
        },
        async mounted() {
            await this.getSearchTableConfig();
        },
        methods: {
            async getSearchTableConfig() {
                const config = await TableConfigService.getConfig('OrderSearch');
                if (config) {
                    // set all current column data to inactive
                    for (const column of this.columnData) {
                        column.isActive = false;
                    }

                    if (config.Result.Columns.length > 0) {
                        for (const dto of config.Result.Columns) {
                            // find matching column data and set to active/disative
                            const col = this.columnData.find(x => x.Field === dto.Field);
                            if (col) {
                                col.isActive = true;
                                col.SortOrder = dto.SortOrder;
                            }
                        }

                        let index = config.Result.Columns.length;

                        for (const col of this.columnData) {
                            if (!col.isActive) {
                                col.SortOrder = index;
                                ++index;
                            }
                        }
                        this.columnData.sort(((a, b) => a.SortOrder - b.SortOrder));
                    }
                }
                else {
                    for(const column of this.columnData) {
                        column.isActive = true;
                    }
                }
            },
            async saveColumns() {
                const config = {
                    TableConfigType: 'OrderSearch',
                    Columns: []
                }

                let index = 0;
                for (const column of this.columnData) {
                    if (column.isActive) {
                        config.Columns.push({
                            Name: column.ColumnName,
                            SortOrder: index++,
                            Field: column.Field,
                            DataType: column.type,
                            Width: column.width ?? '75px',
                        });
                    }
                }

                const result = await TableConfigService.saveConfig(config);

								sessionStorage.removeItem('orderSearchState');
            },
            startDrag(item, i, e) {
                this.startLoc = e.clientY;
                this.dragging = true;
                this.dragFrom = item;
            },
            finishDrag(item, pos) {
                this.columnData.splice(pos, 1)
                this.columnData.splice(this.over.pos, 0, item);
                this.over = {}
            },
            onDragOver(item, pos, e) {
                const dir = (this.startLoc < e.clientY) ? 'down': 'up';
                setTimeout(() => {
                    this.over = { item, pos, dir };        
                }, 50)
            }
        },
    }
</script>

<style scoped lang="scss">
.over {
  opacity: .6;
}

.flip-list-move {
  transition: transform .2s;
}

.list > div {
    display: flex;
    flex-direction: column; 
}

.item {
  width: 600px;
  display: inline-block;
}
</style>
